import { Component } from '@angular/core';

@Component({
  selector: 'app-delete-request-success',
  templateUrl: './delete-request-success.component.html',
  styleUrl: './delete-request-success.component.css'
})
export class DeleteRequestSuccessComponent {

}
